import React from 'react';
import { StudyGuidePie } from './study-guide-pie';
import moment from 'moment';
import { GuideNavWeek, GuideNavWeekDay, GuideNavWeekLink } from '@/components/custom/guide';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';

export function StudyGuideNavWeek({ studyGuide }) {
  const playful = usePlayfulStudent();
  const videosByDate = studyGuide['study-plan-videos'].reduce((acc, video) => {
    const formattedDate = moment(video.date).format('YYYY-MM-DD');
    if (!acc[formattedDate]) {
      acc[formattedDate] = [];
    }
    acc[formattedDate].push(video);
    return acc;
  }, {});

  const sortedDates = Object.keys(videosByDate).sort();

  const calculateCompletionPercentage = videos => {
    const total = videos.length;
    const completed = videos.filter(video => video.done).length;
    return total > 0 && completed > 0 ? (completed / total) * 100 : 0.1;
  };

  const days = sortedDates
    .filter(date => {
      const dayOfWeek = moment(date).day();
      return dayOfWeek >= 1 && dayOfWeek <= 5;
    })
    .map(date => {
      const dayName = moment(date).format('dddd');
      const completionPercentage = calculateCompletionPercentage(videosByDate[date]);

      return {
        name: dayName.slice(0, dayName.indexOf('-')),
        value: completionPercentage
      };
    });

  const currentDay = moment().format('dddd').split('-')[0];

  return (
    // No layout playful (grid main+sidebar de study-guide.jsx) não há coluna
    // reservada pra essa barra ficar fixa como no layout corporativo — em xl
    // ela sobrepunha os itens da semana. Mantemos como pill horizontal normal.
    // `self-start` evita que o flex-col pai (align-items: stretch) estique a
    // barra pra largura total do card — ela deve ocupar só o espaço dos dias.
    <GuideNavWeek className={playful ? 'self-start xl:static xl:flex-row' : undefined}>
      {days?.map(day => {
        const isActive = currentDay.toLowerCase() === day?.name.toLowerCase();
        const href = `#${day?.name.toLowerCase()}`;

        return (
          <GuideNavWeekDay key={day?.name}>
            <GuideNavWeekLink
              href={href}
              isActive={isActive}
              colorScheme={playful ? 'mission' : 'secondary'}
            >
              <StudyGuidePie
                value={day?.value}
                text={day?.name.slice(0, 3)}
                size={44}
                colour={playful ? 'var(--color-mission)' : undefined}
                strokeLineCap={playful ? 'round' : 'butt'}
              />
            </GuideNavWeekLink>
          </GuideNavWeekDay>
        );
      })}
    </GuideNavWeek>
  );
}
